import { useContext } from "react";
import { http } from "~/services/http";
import useSWRMutation from "swr/mutation";
import { PreviewModeContext, isLiveMode } from "~/context/PreviewModeContext";

const fetcher = (url, { arg }) =>
  http.post(`/api/studyfile/${arg.uuid}/merge-chunks`, {
    arg: arg.formData,
  });

export const useMergeChunks = () => {
  const { mode } = useContext(PreviewModeContext);
  const isPreviewOrPrint = !isLiveMode(mode);

  const swrKey = isPreviewOrPrint ? null : "/api/studyfile/mergechunks";
  const {
    trigger: mergeChunks,
    isMutating: isMerging,
    error,
  } = useSWRMutation(swrKey, fetcher);

  if (isPreviewOrPrint) {
    return {
      mergeChunks: () => Promise.resolve(null),
      isMerging: false,
      error: null,
    };
  }

  return { mergeChunks, isMerging, error };
};
